import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper/modules";

const initialize = (sectionData) => {
  const thumbSwiper = new Swiper(`#shopify-section-${sectionData.id} .gd-product-add-to-cart-images .gd-thumb-swiper`, {
    modules: [FreeMode, Thumbs],
    spaceBetween: 16,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper = new Swiper(`#shopify-section-${sectionData.id} .gd-product-add-to-cart-images .gd-swiper`, {
    modules: [Navigation, Pagination, Thumbs],
    // loop: true,
    navigation: {
      nextEl: `#shopify-section-${sectionData.id} .gd-product-add-to-cart-images .gd-swiper .swiper-button-next`,
      prevEl: `#shopify-section-${sectionData.id} .gd-product-add-to-cart-images .gd-swiper .swiper-button-prev`,
    },
    pagination: {
      el: `#shopify-section-${sectionData.id} .gd-product-add-to-cart-images .gd-swiper .swiper-pagination`,
      clickable: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const sectionData = window.gd.sections.filter((s) => s.type == "product-add-to-cart");
  sectionData.forEach((sectionData) => initialize(sectionData));
});
